import { useEffect, useState } from "react"
import "./ImageSelector.css"
import { imgStrToBase64 } from "../ExportUtils"

export default function ImageSelector ({genImages, displayImage}) {
    const [selectIndex, setSelectIndex] = useState(0)

    useEffect(() => {
        setSelectIndex(0)
    }, [genImages])

    const selectImage = e => {
        const index = parseInt(e.target.value)
        displayImage(index)
        setSelectIndex(index)
    }

    return (
        <div className="image-selector">
            {genImages && genImages.map((image, index) => <div 
                className={`image-item ${(selectIndex === index) && "selected"}`} 
                key={index}
                style={{backgroundImage: `url(${imgStrToBase64(image)})`}} 
            />)}
            <input type="range" min="0" max={genImages.length - 1} step="1"
                onChange={selectImage}
                value={selectIndex}
            ></input>
        </div>
    )
}